export { default } from 'features/checkout/routes/checkout-route';
